// extracted by mini-css-extract-plugin
export default {"classNameDisplay":"ClassNameEditor_classNameDisplay__Rp9Dr","classNameInput":"ClassNameEditor_classNameInput__L4a3M"};